/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfMercadoLivreVehicleAttributesModel } from "../models/AjaxResponseOfListOfMercadoLivreVehicleAttributesModel";
import type { AjaxResponseOfMercadoLivreAuthCallbackOutput } from "../models/AjaxResponseOfMercadoLivreAuthCallbackOutput";
import type { MercadoLivreAuthCallbackRequest } from "../models/MercadoLivreAuthCallbackRequest";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class MercadoLivreAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getColors(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-colors",
    });
  }

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getFuelTypes(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-fuel-types",
    });
  }

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getMakes(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-makes",
    });
  }

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getModels(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-models",
    });
  }

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getOptionals(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-optionals",
    });
  }

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getTransmissions(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-transmissions",
    });
  }

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getMakesMotorcycle(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-makes-motorcycle",
    });
  }

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getModelsMotorcycle(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-models-motorcycle",
    });
  }

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getTypeStartMotorcycle(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-type-start-motorcycle",
    });
  }

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getTypeBrakeMotorcycle(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-type-brake-motorcycle",
    });
  }

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getNumberGearsMotorcycle(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-number-gears-motorcycle",
    });
  }

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getTypeEngineMotorcycle(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-type-engine-motorcycle",
    });
  }

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getColorMotorcycle(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-color-motorcycle",
    });
  }

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getOptionalItemsMotorcycle(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-optional-items-motorcycle",
    });
  }

  /**
   * @returns AjaxResponseOfListOfMercadoLivreVehicleAttributesModel
   * @throws ApiError
   */
  public getStyleMotorcycle(): CancelablePromise<AjaxResponseOfListOfMercadoLivreVehicleAttributesModel> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/get-style-motorcycle",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public insertOlxToken({
    requestBody,
  }: {
    requestBody?: MercadoLivreAuthCallbackRequest;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/mercado-livre/token",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfMercadoLivreAuthCallbackOutput
   * @throws ApiError
   */
  public handleAuthCallback({
    code,
    state,
    isSpa = false,
  }: {
    code?: string;
    state?: string;
    isSpa?: boolean;
  }): CancelablePromise<AjaxResponseOfMercadoLivreAuthCallbackOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mercado-livre/handle-auth-callback",
      query: {
        code: code,
        state: state,
        isSpa: isSpa,
      },
    });
  }
}
